import { render } from "./my-button.vue?vue&type=template&id=50cd9225"
import script from "./my-button.vue?vue&type=script&lang=js"
export * from "./my-button.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__